import { renderChildren, useVisibilityObserver } from '@superdispatch/ui';
import {
  ReactNode,
  RefCallback,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { useDebouncedValue } from 'shared/helpers/ReactHelpers';
import { useMarkAsSeenLoadSuggestion } from 'shared/modules/load-suggestions/data/LoadSuggestionsAPI';
import { PostingDTO } from '../data/dto/PostingDTO';

const markedSuggestions = new Set<number>();

interface PostingLoadCardEventProps {
  posting: PostingDTO;
  children: (ref: RefCallback<HTMLElement | undefined>) => ReactNode;
}

export function PostingLoadEventObserver({
  posting,
  children,
}: PostingLoadCardEventProps) {
  const { mutate: markAsSeen } = useMarkAsSeenLoadSuggestion();
  const [node, setNode] = useState<HTMLElement | null>(null);

  const visibilityState = useDebouncedValue(
    useVisibilityObserver(node, { threshold: 1 }),
    600,
  );

  useEffect(() => {
    if (
      visibilityState === 'visible' &&
      posting.suggestion_id &&
      !posting.is_suggestion_seen &&
      !markedSuggestions.has(posting.suggestion_id)
    ) {
      markAsSeen(new Set<number>([posting.suggestion_id]));
      markedSuggestions.add(posting.suggestion_id);
    }
  }, [visibilityState, posting, markAsSeen]);

  const ref = useCallback<RefCallback<HTMLElement>>(
    (nodeElement) => {
      setNode(nodeElement);
    },
    [setNode],
  );

  return renderChildren(children(ref));
}
